module.exports = __webpack_public_path__ + "img/icn-label-image.ad715372.svg";